import { render, staticRenderFns } from "./ModalPin.vue?vue&type=template&id=2fd7755c&"
import script from "./ModalPin.vue?vue&type=script&lang=js&"
export * from "./ModalPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports